"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANG_CSS_PREFIX = void 0;
/*** Component Constants ***/
exports.ANG_CSS_PREFIX = 'ang-search-component';
